<template>
  <div id="side-bar">
    <b-list-group flush class="no-border">
      <!-- :::::::::::::::::::::::::::: MENU RETORNAR SGCQ :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <img
          id="logo"
          class="m-2"
          :src="require('/static/images/logo_sgcq_w.png')"
          aria-label="Logomarca do SGCQ"
          width="130"
          @click="display('SGCQ')"
        />
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LIST :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <b-icon icon="slack" animation="spin" class="mr-3" /> Menu de Opções
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LISTA DE CERTIFICADOS :::::::::::::::::::::::::::: -->
      <b-list-group-item button class="menu-top" @click="listaDeEquipamentos()">
        <b-icon variant="info" icon="tools" class="mr-3" /> Lista de Equipamentos
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('CERTIFICADO')">
        <b-icon variant="info" icon="journal-check" class="mr-3" />Certificado
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('LT')">
        <b-icon variant="info" icon="gear" class="mr-3" />Laudo Técnico
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('PLM')">
        <b-icon variant="info" icon="gear" class="mr-3" />Plano de Manutenção
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('CK')">
        <b-icon variant="info" icon="ui-checks" class="mr-3" />Checklist
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('RF')">
        <b-icon variant="info" icon="images" class="mr-3" />Registro Fotográfico
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('RI')">
        <b-icon variant="info" icon="file-break" class="mr-3" />Relatório de Inspeção
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('PM')">
        <b-icon variant="info" icon="file-break" class="mr-3" />Partículas Magnéticas
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('LP')">
        <b-icon variant="info" icon="file-break" class="mr-3" />Líquido Penetrante
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('ME')">
        <b-icon variant="info" icon="file-break" class="mr-3" />Medição de Espessura
      </b-list-group-item>
      <b-list-group-item button class="menu-top" @click="display('TE')">
        <b-icon variant="info" icon="compass" class="mr-3" />Teste de Carga / Hidrostático
      </b-list-group-item>
      <b-list-group-item variant="secondary" button>
        <b-icon variant="info" icon="journals" class="mr-3" />Prontuário de NR-13
      </b-list-group-item>
    </b-list-group>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <equipamento-list ref="equipamentoLista" />
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import EquipamentoListModal from "@/components/modals/equipamento/EquipamentoListModal";
import Aba from "@/models/Aba";

export default {
  name: "SideBarDoCertificado",

  components: {
    "equipamento-list": EquipamentoListModal,
  },

  data() {
    return {};
  },

  methods: {
    display(nomeDoReport) {
      let check = false;
      this.reports.findIndex((value) => {
        if (value.tipo == nomeDoReport) {
          check = true;
        }
      });
      switch (nomeDoReport) {
        case "SGCQ":
          this.$router.push({ path: "/sgcq" });
          break;
        default:
          if (check) {
            this.store.REMOVE_REPORT(nomeDoReport);
          } else {
            this.store.ADICIONA_REPORT(new Aba(nomeDoReport, true, null));
          }
      }
    },

    listaDeEquipamentos() {
      this.$refs.equipamentoLista.call();
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getFilterEquipamentos } = storeToRefs(equipamentoStore);

    return {
      store,
      reports: store.getReports,
      equipamentoStore,
      getFilterEquipamentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#side-bar {
  display: inline-block;
  width: 20%;
  height: 99vh;
  background-color: #112a4a;
  overflow: scroll;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  left: 0;
  text-align: start;
}

.menu-top {
  background-color: #112a4a;
  color: #fff;
  border: none;
}
</style>
